<!-- <mat-toolbar *ngIf="data.mobileType === 'android'" color="primary" class="android-prompt">
  <button mat-button (click)="installPwa()">
    Add to Home screen
  </button>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar> -->

<!-- <div *ngIf="data.mobileType === 'ios'" class="ios-prompt">
  <button class="close-ios-inv" mat-button color="primary" (click)="close()"><mat-icon>close</mat-icon></button>
  <div>To install this web app on your device, open in Safari, tap the Menu button and then 'Add to Home screen' button</div>
  <div>
    <img src="assets/ios-menu-btn.png">
    <mat-icon>navigate_next</mat-icon>
    <img src="assets/ios-add-btn.png"></div>
</div> -->

<div class="ios-prompt">
  <button class="close-ios-inv" mat-button color="primary" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
  <div>
    For a superior experience, download and install the Brain Changer App on
    your phone!
    <br />
    <a class="bc-yellow-text" [href]="downloadLink" target="_blank"
      >Click here</a
    >
    to download the app
  </div>
  <div>
    <a [href]="downloadLink" target="_blank" class="download-link">
      <img
        style="margin-top: -5%; margin-bottom: -5%"
        *ngIf="data.mobileType === 'ios'"
        src="assets/app-store-logo.png"
      />
      <img
        style="margin-top: -25%; margin-bottom: -25%"
        *ngIf="data.mobileType === 'android'"
        src="assets/google-play-logo.png"
      />
    </a>
  </div>
</div>
